<template>
  <div class="about">
    <h1>This is an about page</h1>

    <button v-on:click="show = !show">
      Переключить
    </button>
    <transition name="fade">
      <p v-if="show">привет</p>
    </transition>

  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true
    }
  }
}
</script>

